import React from 'react';
import Footer from '../Components/Footer';

const Donnees = () => {
  // Styles réutilisables
  const sectionStyle = {
    marginBottom: '2.5rem',
    background: 'rgba(15, 23, 42, 0.5)',
    borderRadius: '12px',
    overflow: 'hidden',
    border: '1px solid rgba(255, 255, 255, 0.05)'
  };

  const sectionHeaderStyle = {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: '#ffffff',
    margin: 0,
    padding: '1.25rem 2rem',
    background: 'linear-gradient(90deg, rgba(14, 165, 233, 0.2) 0%, rgba(59, 130, 246, 0.2) 100%)',
    borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem'
  };

  const sectionContentStyle = {
    padding: '1.5rem 2rem'
  };

  const paragraphStyle = {
    color: '#e2e8f0', 
    margin: '0 0 1rem 0',
    lineHeight: '1.7'
  };

  const listStyle = {
    paddingLeft: '1.5rem',
    margin: '0 0 1rem 0'
  };

  const listItemStyle = {
    marginBottom: '0.75rem',
    lineHeight: '1.7',
    position: 'relative',
    paddingLeft: '1.5rem'
  };

  const highlightStyle = {
    color: '#0ea5e9',
    fontWeight: 600
  };

  const badgeStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '2rem',
    height: '2rem',
    borderRadius: '50%',
    background: 'rgba(14, 165, 233, 0.1)',
    color: '#0ea5e9',
    marginRight: '0.75rem',
    flexShrink: 0
  };

  const buttonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '0.75rem 1.5rem',
    background: '#0ea5e9',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    textDecoration: 'none',
    marginTop: '1rem',
    ':hover': {
      background: '#0d94d8'
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      background: 'linear-gradient(135deg, #0f172a 0%, #111827 35%, #0b1220 100%)',
      color: 'white',
      padding: '2rem 0'
    }}>
      <main style={{
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 1rem'
      }}>
        <div style={{ 
          textAlign: 'center', 
          marginBottom: '3rem',
          padding: '2rem',
          background: 'rgba(255, 255, 255, 0.03)',
          borderRadius: '16px',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <h1 style={{
            fontSize: '2.5rem',
            fontWeight: 800,
            color: '#ffffff',
            marginBottom: '1rem',
            background: 'linear-gradient(90deg, #0ea5e9, #3b82f6)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: 'inline-block'
          }}>
            Protection des Données Personnelles
          </h1>
          <p style={{
            fontSize: '1.125rem',
            color: '#94a3b8',
            maxWidth: '800px',
            margin: '0 auto'
          }}>
            Dernière mise à jour : 31 octobre 2025
          </p>
        </div>

        <div style={{
          backgroundColor: 'rgba(15, 23, 42, 0.7)',
          borderRadius: '16px',
          boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.3), 0 8px 10px -6px rgba(0, 0, 0, 0.2)',
          overflow: 'hidden',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <div style={{ 
            padding: '2.5rem',
            background: 'linear-gradient(180deg, rgba(30, 41, 59, 0.5) 0%, rgba(15, 23, 42, 0.7) 100%)'
          }}>
            {/* Introduction */}
            <section style={{ 
              marginBottom: '3rem',
              padding: '2rem',
              background: 'rgba(15, 23, 42, 0.5)',
              borderRadius: '12px',
              border: '1px solid rgba(255, 255, 255, 0.05)'
            }}>
              <p style={{
                color: '#e2e8f0',
                lineHeight: '1.7',
                fontSize: '1.1rem',
                margin: 0
              }}>
                Chez AidFoundation, nous accordons une importance primordiale à la protection de vos données personnelles. Cette page vous informe sur vos droits et sur la manière dont nous protégeons vos informations conformément au Règlement Général sur la Protection des Données (RGPD) et à la législation en vigueur.
              </p>
            </section>

            {/* Article 1 : Droits des utilisateurs */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                <span style={badgeStyle}>1</span>
                Vos droits
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Conformément à la réglementation en vigueur, vous disposez des droits suivants concernant vos données personnelles :
                </p>
                <ul style={listStyle}>
                  <li style={listItemStyle}>
                    <span style={highlightStyle}>Droit d'accès :</span> Vous pouvez demander une copie de vos données personnelles que nous détenons.
                  </li>
                  <li style={listItemStyle}>
                    <span style={highlightStyle}>Droit de rectification :</span> Vous pouvez demander la correction de données inexactes ou incomplètes.
                  </li>
                  <li style={listItemStyle}>
                    <span style={highlightStyle}>Droit à l'effacement :</span> Vous pouvez demander la suppression de vos données personnelles sous certaines conditions.
                  </li>
                  <li style={listItemStyle}>
                    <span style={highlightStyle}>Droit à la limitation du traitement :</span> Vous pouvez demander de limiter l'utilisation de vos données.
                  </li>
                  <li style={listItemStyle}>
                    <span style={highlightStyle}>Droit à la portabilité :</span> Vous pouvez recevoir vos données dans un format structuré et les transmettre à un autre responsable de traitement.
                  </li>
                  <li style={{...listItemStyle, marginBottom: 0}}>
                    <span style={highlightStyle}>Droit d'opposition :</span> Vous pouvez vous opposer au traitement de vos données pour des raisons tenant à votre situation particulière.
                  </li>
                </ul>
                <p style={paragraphStyle}>
                  Pour exercer ces droits, veuillez nous contacter à l'adresse suivante :{' '}
                  <a href="mailto:donnees@unpaidfinancial.com" style={{color: '#0ea5e9', textDecoration: 'none'}}>
                    donnees@unpaidfinancial.com
                  </a>
                </p>
              </div>
            </section>

            {/* Article 2 : Sécurité des données */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                <span style={badgeStyle}>2</span>
                Sécurité de vos données
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre tout accès non autorisé, altération, divulgation ou destruction. Ces mesures incluent notamment :
                </p>
                <ul style={listStyle}>
                  <li style={listItemStyle}>
                    <span style={highlightStyle}>Chiffrement :</span> Utilisation de protocoles de chiffrement avancés pour protéger les données en transit et au repos.
                  </li>
                  <li style={listItemStyle}>
                    <span style={highlightStyle}>Authentification forte :</span> Mise en place d'une authentification à plusieurs facteurs pour accéder à votre compte.
                  </li>
                  <li style={listItemStyle}>
                    <span style={highlightStyle}>Surveillance continue :</span> Surveillance 24/7 de nos systèmes pour détecter et prévenir les activités suspectes.
                  </li>
                  <li style={{...listItemStyle, marginBottom: 0}}>
                    <span style={highlightStyle}>Formation du personnel :</span> Tous nos employés suivent des formations régulières sur la protection des données.
                  </li>
                </ul>
              </div>
            </section>

            {/* Article 3 : Transferts de données */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                <span style={badgeStyle}>3</span>
                Transferts de données
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Dans le cadre de nos activités, il est possible que nous transférions des données vers des pays situés en dehors de l'Espace Économique Européen (EEE). Dans ce cas, nous nous assurons que des garanties appropriées sont mises en place, telles que :
                </p>
                <ul style={listStyle}>
                  <li style={listItemStyle}>
                    Des décisions d'adéquation de la Commission européenne
                  </li>
                  <li style={listItemStyle}>
                    Des clauses contractuelles types
                  </li>
                  <li style={{...listItemStyle, marginBottom: 0}}>
                    Des règles d'entreprise contraignantes
                  </li>
                </ul>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  Vous pouvez obtenir plus d'informations sur les garanties mises en place en nous contactant à l'adresse indiquée ci-dessus.
                </p>
              </div>
            </section>

            {/* Article 4 : Délégué à la protection des données */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                <span style={badgeStyle}>4</span>
                Délégué à la protection des données (DPO)
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Conformément au RGPD, nous avons désigné un Délégué à la Protection des Données (DPO) qui peut être contacté pour toute question relative à la protection de vos données personnelles :
                </p>
                <p style={paragraphStyle}>
                  <span style={highlightStyle}>Email :</span>{' '}
                  <a href="mailto:dpo@unpaidfinancial.com" style={{color: '#0ea5e9', textDecoration: 'none'}}>
                    dpo@unpaidfinancial.com
                  </a>
                </p>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  <span style={highlightStyle}>Adresse postale :</span> Délégué à la Protection des Données, AidFoundation, 123 Avenue de la Banque, 75001 Paris, France
                </p>
              </div>
            </section>

            {/* Article 5 : Réclamation auprès de la CNIL */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                <span style={badgeStyle}>5</span>
                Réclamation auprès de la CNIL
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Si vous estimez, après nous avoir contactés, que vos droits sur vos données ne sont pas respectés, vous avez le droit d'introduire une réclamation auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL) :
                </p>
                <p style={paragraphStyle}>
                  <span style={highlightStyle}>En ligne :</span>{' '}
                  <a 
                    href="https://www.cnil.fr" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{color: '#0ea5e9', textDecoration: 'none'}}
                  >
                    www.cnil.fr
                  </a>
                </p>
                <p style={paragraphStyle}>
                  <span style={highlightStyle}>Par courrier :</span> CNIL - 3 Place de Fontenoy - TSA 80715 - 75334 PARIS CEDEX 07
                </p>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  <span style={highlightStyle}>Téléphone :</span> 01 53 73 22 22
                </p>
              </div>
            </section>

            {/* Bouton de contact */}
            <div style={{ textAlign: 'center', marginTop: '3rem' }}>
              <a 
                href="mailto:donnees@unpaidfinancial.com" 
                style={buttonStyle}
              >
                Nous contacter au sujet de vos données
              </a>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Donnees;